'use client'
import type { SbBlokData } from '@storyblok/react'
import { storyblokEditable, StoryblokComponent } from '@storyblok/react'
import { PageBannerTriggers } from '@/components/Banner/PageBannerTriggers'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { gridRoot, wrapper } from './ProductPageBlock.css'

export type ProductPageBlockFields = {
  productBody: Array<SbBlokData>
  productHeroFirstColumn: Array<SbBlokData>
  productHeroSecondColumn: Array<SbBlokData>
  v2Enabled?: boolean
}

export type ProductPageBlockProps = SbBaseBlockProps<ProductPageBlockFields>

export const ProductPageBlock = ({ blok }: ProductPageBlockProps) => {
  return (
    <main className={wrapper} data-header-mode="sticky" {...storyblokEditable(blok)}>
      {/* Allows campaign banner, but no CMS-defined banner is supported for product pages so far */}
      <PageBannerTriggers blok={{}} />
      <GridLayout.Root className={gridRoot}>
        <GridLayout.Content width={{ lg: '1/2' }} align="left">
          {blok.productHeroFirstColumn.map((nestedBlock) => (
            <StoryblokComponent blok={nestedBlock} key={nestedBlock._uid} nested={true} />
          ))}
        </GridLayout.Content>
        <GridLayout.Content width={{ lg: '1/2' }} align="right">
          {blok.productHeroSecondColumn.map((nestedBlock) => (
            <StoryblokComponent blok={nestedBlock} key={nestedBlock._uid} nested={true} />
          ))}
        </GridLayout.Content>
      </GridLayout.Root>

      {blok.productBody.map((nestedBlock) => (
        <StoryblokComponent blok={nestedBlock} key={nestedBlock._uid} />
      ))}
    </main>
  )
}
